import type { Supervisor } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleSupervisorQueryResult {
  supervisor: Supervisor
}

export interface SingleSupervisorQueryVariables {
  id?: GQL_ID
}

const GQL_QUERY_SINGLE_SUPERVISOR = gql`
  query (
    $id: ID!
  ) {
    supervisor: singleSupervisor(
      id: $id
    ) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      email
      shops {
        id
        name
      }
    }
  }
`

export const useFetchSingleSupervisor = (
  variables: SingleSupervisorQueryVariables
) =>
  useQuery<SingleSupervisorQueryResult, SingleSupervisorQueryVariables>(
    GQL_QUERY_SINGLE_SUPERVISOR,
    { variables, skip: !variables.id }
  )
